import type { TranslatableText } from '@zag/core/common';

type FeatureMetaTranslations = Readonly<{
  readonly name: Readonly<Record<keyof TranslatableText<'name' | 'description'>, string>>;
  readonly description?: Readonly<Record<keyof TranslatableText<'name' | 'description'>, string>>;
}>;

export interface FeatureMeta {
  readonly name: string;
  readonly translations?: FeatureMetaTranslations;
  readonly description?: string;
}

export interface FeatureContribution {
  readonly moduleKey: string;
  readonly features: readonly string[];
  readonly featureMeta?: Readonly<Record<string, FeatureMeta>>;
  readonly gatedByFlag?: boolean;
}
